import React, { Suspense } from 'react';
import type { ReactNode } from 'react';
import { useOutletContext } from 'react-router-dom';
import RightPanelContainer from './RightPanelContainer';

export interface OutletContextValue {
  shouldShiftContentForRightPanel: boolean;
  helpMenu?: JSX.Element;
}

interface PageProps {
  topbar?: ReactNode;
  children: React.ReactNode;
}

const Page = ({ topbar, children }: PageProps) => {
  const { shouldShiftContentForRightPanel, helpMenu } =
    useOutletContext<OutletContextValue>();

  return (
    <>
      {topbar}
      <div id="inner">
        <Suspense fallback={null}>{children}</Suspense>
        <RightPanelContainer shiftContent={shouldShiftContentForRightPanel} />
        {helpMenu}
      </div>
    </>
  );
};

export default Page;
